import React, { useState, useEffect } from "react";
import _ from "lodash";
import CONSTANTS from "./helpers/CONSTANTS";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import QuestionDialog from "./common/QuestionDialog";
import MenuBar from "./common/MenuBar";
import InfoBar from "./common/InfoBar";
import IncreaseAge from "./IncreaseAge";
import LifeLog from "./LifeLog";
import StatDialog from "./StatDialog";
import AboutDialog from "./AboutDialog";
import NullSpinner from "./common/NullSpinner";
import getQuestions from "./helpers/getQuestions";
import updateNetworth from "./helpers/updateNetworth";

const useStyles = makeStyles((theme) => ({
	agePaper: {
		marginTop: 7,
		textAlign: "center",
		minWidth: "250px",
		maxWidth: "350px",
	},
	lifeGutter: {
		marginTop: 7,
		paddingBottom: 10,
	},
}));

const Home = () => {
	const classes = useStyles();

	// Setting store state
	const [isConstructed, setIsConstructed] = useState(false);
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [gender, setGender] = useState("");

	// Setting game state variables
	const [age, setAge] = useState(0);
	const [networth, setNetworth] = useState(0);
	const [contentHistory, setContentHistory] = useState([]);

	// Question state
	const [question, setQuestion] = useState({
		qHeading: "",
		qContent: "",
		qYes: "",
		qNo: "",
		qYesLog: "",
		qNoLog: "",
	});
	const [isQuestion, setIsQuestion] = useState(false);
	const [questionsReady, setQuestionsReady] = useState(false);

	// Stat states
	const [stats, setStats] = useState({
		luck: 0,
		happiness: 0,
		health: 0,
		thinkingPower: 0,
		looks: 0,
	});
	const [showStats, setShowStats] = useState(false);

	// About state
	const [showAbout, setShowAbout] = useState(false);

	// Setting age general log state
	const [ageLog, setAgeLog] = useState("");

	/// TODO: remove. TESTING DATA API STATE
	const [TESTDATARETURN, setTESTDATARETURN] = useState({});
	const [TESTQUESTIONS, setTESTQUESTIONS] = useState({});

	// Updating age and history based on new year
	const upAgeHandler = () => {
		// Should there be a question?
		let questionRoll = Math.floor(Math.random() * 11) > 5 ? true : false;

		// Handling questions
		if (questionRoll && questionsReady && age !== 21 && age !== 0) {
			setQuestion({
				qHeading: TESTQUESTIONS[`age${age}`][0].questionTitle,
				qContent: TESTQUESTIONS[`age${age}`][0].questionBody,
				qYes: TESTQUESTIONS[`age${age}`][0].qYes,
				qNo: TESTQUESTIONS[`age${age}`][0].qNo,
				qYesLog: TESTQUESTIONS[`age${age}`][0].qYesLog,
				qNoLog: TESTQUESTIONS[`age${age}`][0].qNoLog,
			});

			setAgeLog(
				TESTDATARETURN[`age${age}`][
					Math.floor(Math.random() * TESTDATARETURN[`age${age}`].length)
				]
			);

			setIsQuestion(true);

			return true;
		} else if (age === 21) {
			appendHistory(
				"This was just a testy boi. Follow the Instagram for update: @cessnocklife"
			);
			return true;
		} else if (age === 0) {
			appendHistory(TESTDATARETURN.age0);

			// Updating networth
			updateNetworth(networth, setNetworth, age);

			return true;
		} else {
			appendHistory(
				TESTDATARETURN[`age${age}`][
					Math.floor(Math.random() * TESTDATARETURN[`age${age}`].length)
				]
			);

			// Updating networth
			updateNetworth(networth, setNetworth, age);

			return true;
		}
	};

	const answerHandler = (response) => {
		// Updating networth
		updateNetworth(networth, setNetworth, age);

		// Handling answer
		if (response === "Yes") {
			// Closing question
			setIsQuestion(false);

			const content = `${ageLog} ${question.qYesLog}`;

			// Updating history
			appendHistory(content);

			// Defaulting question
			setQuestion({
				qHeading: "",
				qContent: "",
				qYes: "",
				qNo: "",
				qYesLog: "",
				qNoLog: "",
			});

			// Defaulting ageLog
			setAgeLog("");
		} else {
			// Closing question
			setIsQuestion(false);

			const content = `${ageLog} ${question.qNoLog}`;

			// Updating history
			appendHistory(content);

			// Defaulting question
			setQuestion({
				qHeading: "",
				qContent: "",
				qYes: "",
				qNo: "",
				qYesLog: "",
				qNoLog: "",
			});

			// Defaulting ageLog
			setAgeLog("");
		}
	};

	const appendHistory = (content) => {
		// Creating new history object
		const newHistory = {
			age: age,
			content: content,
		};

		// Cloning the current hisotry state array
		let updateHistory = _.cloneDeep(contentHistory);

		// Updating the cloned array
		updateHistory.push(newHistory);

		// Setting state to updated array
		setContentHistory(updateHistory);

		// Setting age
		setAge(age + 1);

		return true;
	};

	// USED FOR TESTING -- CURRENTLY SETTING STATES
	useEffect(() => {
		// Getting data from backend
		// Need to first create the function and then call as useEffect mean to async/await
		const getNew = async () => {
			try {
				// Attempting to get a new user object
				let newUser = await fetch(`${CONSTANTS.backend}api/new`);
				newUser = await newUser.json();

				setFirstName(newUser.firstName);
				setLastName(newUser.lastName);
				setNetworth(9);
				setGender(newUser.gender);

				setStats({
					luck: newUser.luck,
					happiness: newUser.happiness,
					health: newUser.health,
					thinkingPower: newUser.thinkingPower,
					looks: newUser.looks,
				});

				// Getting life log content
				let lifeLogContent = await fetch(
					`${CONSTANTS.backend}api/lifeContent/?gender=${newUser.gender}`
				);
				lifeLogContent = await lifeLogContent.json();

				// TODO: This needs to be updated to not be fucked -- it's fucked so I can ensure
				// The data is coming back from the DB correctly
				let content = {
					age0: `I'm born in ${newUser.suburb}.`,
				};

				for (let i = 0; i < lifeLogContent.length; i++) {
					if (!content.hasOwnProperty(`age${lifeLogContent[i].age}`)) {
						content[`age${lifeLogContent[i].age}`] = [];
					}

					content[`age${lifeLogContent[i].age}`].push(
						lifeLogContent[i].content
					);
				}

				// Setting life log content state
				setTESTDATARETURN(content);

				// Allows user to start playing
				setIsConstructed(true);

				// Getting questions
				const questions = await getQuestions(
					setTESTQUESTIONS,
					setQuestionsReady,
					newUser.gender
				);

				// Throwing error if issue with questions
				if (!questions) {
					throw new Error("Issue getting questions");
				}
			} catch (err) {
				console.log(`Error fetching: ${err}`);
			}
		};

		// If user not yet constructed, constructing
		if (!isConstructed) {
			getNew();
		}
	}, [isConstructed]);

	return (
		<div>
			{/* TODO: below being tested -- need to add action so only displays on click of stats
			button */}
			{showStats ? (
				<StatDialog
					stats={stats}
					setShowStats={setShowStats}
					name={firstName}
				/>
			) : (
				""
			)}

			{showAbout ? <AboutDialog setShowAbout={setShowAbout} /> : ""}

			{isQuestion ? (
				<QuestionDialog
					qHeading={question.qHeading}
					qContent={question.qContent}
					qYes={question.qYes}
					qNo={question.qNo}
					answerHandler={answerHandler}
				/>
			) : (
				""
			)}
			<MenuBar setShowStats={setShowStats} setShowAbout={setShowAbout} />
			<InfoBar
				networth={networth}
				firstName={firstName}
				lastName={lastName}
				gender={gender}
			/>

			{/* TODO: BELOW IS ONLY FOR TESTING TO REMOVE BUTTON */}
			{age > 21 || !isConstructed ? (
				<NullSpinner checky={age} nullTrigger={21} />
			) : (
				<IncreaseAge upAgeHandler={upAgeHandler} />
			)}

			<Grid container direction="column" justify="center" alignItems="center">
				<Grid item>
					<Paper className={classes.agePaper}>
						<Typography variant="h4" component="h1">
							<span role="img" aria-label="Tree emoji">
								🌲
							</span>{" "}
							Life Log{" "}
							<span role="img" aria-label="Tree emoji">
								🌲
							</span>
						</Typography>

						<Grid
							container
							direction="column"
							justify="center"
							alignItems="center"
						>
							{contentHistory
								.map((logItem) => {
									return (
										<LifeLog age={logItem.age} content={logItem.content} />
									);
								})
								.reverse()}
						</Grid>

						<div className={classes.lifeGutter}>
							<span role="img" aria-label="seedling emoji">
								🌱
							</span>
						</div>
					</Paper>
				</Grid>
			</Grid>
		</div>
	);
};

export default Home;
